import en from './en'

export const I18n = {
  get(id) {
    return en[id]
  },
}

export default I18n
